import {
  DialogActions,
  DialogContent,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import React, { ChangeEvent, useState } from 'react';
import { Button } from '../common/Button';
import { DialogTitle } from '../common/Dialog';
import { CloseIconButton } from '../common/IconButton';
import { Switch } from '../common/Switch';
import { Typography } from '../common/Typography';

export interface TourModeModalProps {
  onClose: () => void;
  onConfirm: (config: WaypointOptions) => void;
  initialConfig: WaypointOptions;
  cancelButtonLabel: string;
  confirmButtonLabel: string;
  description?: string;
}

export type WaypointOptions = null | 'none' | '2' | 'all';

const displayedOptions: WaypointOptions[] = ['2', 'all'];

export const TourModeModal: React.FC<TourModeModalProps> = ({
  onClose,
  onConfirm,
  initialConfig,
  description,
  cancelButtonLabel,
  confirmButtonLabel,
}) => {
  const [waypointsShown, setWaypointsShown] = useState<WaypointOptions>(initialConfig || 'none');
  const toggleTourMode = () =>
    waypointsShown === 'all' || waypointsShown === '2'
      ? setWaypointsShown('none')
      : setWaypointsShown(displayedOptions[0]);
  const handleConfirm = () => onConfirm(waypointsShown);
  const handleChange = ({ target }: ChangeEvent<HTMLInputElement>) =>
    setWaypointsShown(target.value as WaypointOptions);

  return (
    <>
      <DialogTitle>Activate Tour Mode?</DialogTitle>
      <DialogContent>
        <Typography>{description}</Typography>
        <Grid container alignItems='center' spacing={1}>
          <Grid item>
            <Typography>Gallery</Typography>
          </Grid>
          <Grid item>
            <Switch
              checked={displayedOptions.includes(waypointsShown)}
              onChange={toggleTourMode}
              size={'small'}
            />
          </Grid>
          <Grid item>
            <Typography>Tour</Typography>
          </Grid>
        </Grid>
        {displayedOptions.includes(waypointsShown) && (
          <>
            <RadioGroup
              aria-label='select shown waypoints'
              value={waypointsShown}
              onChange={handleChange}
            >
              {displayedOptions.map((option) => (
                <FormControlLabel
                  value={option}
                  control={<Radio color={'primary'} />}
                  label={`Show ${option} waypoints`}
                  key={`waypoint-option-${option}`}
                />
              ))}
            </RadioGroup>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant='outlined'>
          {cancelButtonLabel}
        </Button>
        <Button onClick={handleConfirm}>{confirmButtonLabel}</Button>
        <CloseIconButton onClick={onClose} />
      </DialogActions>
    </>
  );
};
